/*
 * Copyright (c) 2020 wlocalhost.org.
 * All rights reserved.
 */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IBorder } from '../interfaces/interfaces';
import { IpEmailObjectStoreService } from '../services/internals/ip-email-object-store/ip-email-object-store.service';

@Component({
  selector: 'ip-border',
  template: `
    <div class="group" [class.three]="isEven()">
      <mat-form-field appearance="outline" *ngIf="hasOwnProperty('width')">
        <mat-label i18n="Border Settings|Change Border Width">Width</mat-label>
        <input
          matInput
          [(ngModel)]="border.width"
          type="number"
          min="0"
          step="1"
          (input)="markForCheck()"
          i18n-placeholder
          placeholder="Border Settings|Change Border Width"
        />
      </mat-form-field>
      <mat-form-field appearance="outline" *ngIf="hasOwnProperty('radius')">
        <mat-label i18n="Border Settings|Change Border Radius">Radius</mat-label>
        <input
          matInput
          [(ngModel)]="border.radius"
          type="number"
          min="0"
          step="1"
          (input)="markForCheck()"
          i18n-placeholder
          placeholder="Border Settings|Change Border Radius"
        />
      </mat-form-field>
      <mat-form-field appearance="outline" *ngIf="hasOwnProperty('style')" style="min-width: 90px">
        <mat-label i18n="Border Settings|Change Border Style">Style</mat-label>
        <mat-select
          placeholder="Style"
          [disabled]="!border.width"
          [(value)]="border.style"
          (selectionChange)="markForCheck()"
          disableRipple
        >
          <mat-option *ngFor="let style of styleLabels" [value]="style">
            {{ getStyleLabel(style) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <ip-color [options]="border" [disabled]="!border.width" *ngIf="hasOwnProperty('color')" key="color"></ip-color>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
      }

      mat-form-field {
        width: 100%;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BorderComponent {
  @Input() border: IBorder;

  constructor(private emailObject: IpEmailObjectStoreService) {}

  private _styleLabels = new Map<IBorder['style'], string>([
    ['solid', $localize`:@@border_style_solid:Solid`],
    ['dotted', $localize`:@@border_style_dotted:Dotted`],
    ['dashed', $localize`:@@border_style_dashed:Dashed`],
    ['double', $localize`:@@border_style_double:Double`],
    ['groove', $localize`:@@border_style_groove:Groove`]
  ]);

  get styleLabels(): IBorder['style'][] {
    return [...this._styleLabels.keys()];
  }

  getStyleLabel(style: IBorder['style']): string {
    // tslint:disable-next-line:no-non-null-assertion
    return this._styleLabels.get(style)!;
  }

  markForCheck() {
    this.emailObject.markForCheck();
  }

  isEven(): boolean {
    return Object.keys(this.border).length % 2 === 0;
  }

  hasOwnProperty(property: string): boolean {
    return this.border.hasOwnProperty(property);
  }
}
